export async function sha256(message: string): Promise<string> {
  // encode as UTF-8
  const msgBuffer = new TextEncoder().encode(message);
  // hash the message
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
  // convert ArrayBuffer to Array
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  // convert bytes to hex string
  return hashArray
    .map((b, i) => {
      const hex = b.toString(16).padStart(2, '0');
      return i > 0 && i % 4 == 0 ? ' ' + hex : hex;
    })
    .join('');
}

export function guid(): string {
  return crypto.randomUUID();
}
